import angular from 'angular';
// import _ from 'lodash';

(function () {
    'use strict';
    angular.module('app.core').factory('InvBuyerLinkRequestFilter', InvBuyerLinkRequestFilterData);

    function InvBuyerLinkRequestFilterData() {
        InvBuyerLinkRequestFilter.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            prepareBeforeSearch: prepareBeforeSearch,
        };

        function InvBuyerLinkRequestFilter(invBuyerLinkRequestFilterData) {
            if (!invBuyerLinkRequestFilterData) {
                this.buildEmpty();
            } else {
                this.build(invBuyerLinkRequestFilterData);
            }
        }

        return InvBuyerLinkRequestFilter;

        function buildEmpty() {
            this.buyerId = null;
            this.sellerId = null;
            this.buyerSubEntityId = null;
            this.sellerSubEntityId = null;
            this.linkRequestStatus = null;
        }

        function build(invBuyerLinkRequestFilterData) {
            this.buyerId = invBuyerLinkRequestFilterData.buyer || null;
            this.sellerId = invBuyerLinkRequestFilterData.seller || null;
            this.buyerSubEntityId = invBuyerLinkRequestFilterData.buyerSubEntityId || null;
            this.sellerSubEntityId = invBuyerLinkRequestFilterData.sellerSubEntityId || null;
            this.linkRequestStatus = invBuyerLinkRequestFilterData.linkRequestStatus || null;
        }

        function prepareBeforeSearch() {
            var clone = new InvBuyerLinkRequestFilter(this);
            clone.buyerId = this.buyerId ? this.buyerId.id : null;
            clone.sellerId = this.sellerId ? this.sellerId.id : null;
            clone.buyerSubEntityId = this.buyerSubEntityId ? this.buyerSubEntityId.id : null;
            clone.sellerSubEntityId = this.sellerSubEntityId ? this.sellerSubEntityId.id : null;
            clone.linkRequestStatus = this.linkRequestStatus ? this.linkRequestStatus.value : null ;
            return clone;
        }
    }
})();
